/**
 * Client-side currency display converter.
 *
 * Reads daily USD exchange rates published to the shop.metafields.custom.currency_rates
 * metafield (see #currency-rates-data in layout/theme.liquid), converts every price
 * carrying a data-price-cents attribute, and lets the customer override the auto-detected
 * currency via a cookie. Display-only — checkout always charges in USD.
 */
(function () {
  var COOKIE_NAME = 'serpent_currency';
  var COOKIE_DAYS = 365;
  var DEFAULT_CURRENCY = 'USD';

  var COUNTRY_TO_CURRENCY = {
    US: 'USD',
    JP: 'JPY',
    KR: 'KRW',
    SG: 'SGD',
    GB: 'GBP',
    CA: 'CAD',
    AU: 'AUD',
    NZ: 'NZD',
    CH: 'CHF',
    MX: 'MXN',
    AE: 'AED',
    TH: 'THB',
    // Eurozone
    AT: 'EUR', BE: 'EUR', CY: 'EUR', EE: 'EUR', FI: 'EUR', FR: 'EUR',
    DE: 'EUR', GR: 'EUR', IE: 'EUR', IT: 'EUR', LV: 'EUR', LT: 'EUR',
    LU: 'EUR', MT: 'EUR', NL: 'EUR', PT: 'EUR', SK: 'EUR', SI: 'EUR', ES: 'EUR'
  };

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function loadRates() {
    var el = document.getElementById('currency-rates-data');
    if (!el || !el.textContent.trim()) return null;
    try {
      var data = JSON.parse(el.textContent);
      if (data && data.rates && Object.keys(data.rates).length) return data;
    } catch (e) {
      // malformed/missing metafield — fall through to null
    }
    return null;
  }

  var ratesData = loadRates();
  var SUPPORTED = ratesData ? Object.keys(ratesData.rates) : [DEFAULT_CURRENCY];

  function isSupported(code) {
    return SUPPORTED.indexOf(code) !== -1;
  }

  function detectRegionCurrency() {
    var country = window.Shopify && window.Shopify.country;
    if (country && COUNTRY_TO_CURRENCY[country] && isSupported(COUNTRY_TO_CURRENCY[country])) {
      return COUNTRY_TO_CURRENCY[country];
    }
    return DEFAULT_CURRENCY;
  }

  function getActiveCurrency() {
    var cookieValue = getCookie(COOKIE_NAME);
    if (cookieValue && isSupported(cookieValue)) return cookieValue;
    return detectRegionCurrency();
  }

  var activeCurrency = getActiveCurrency();

  function formatMoney(cents, currency) {
    var amount = (parseFloat(cents) / 100) * (ratesData.rates[currency] || 1);
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(amount);
    } catch (e) {
      return amount.toFixed(2) + ' ' + currency;
    }
  }

  function convertAll() {
    if (!ratesData) return;
    var els = document.querySelectorAll('[data-price-cents]');
    for (var i = 0; i < els.length; i++) {
      var cents = els[i].getAttribute('data-price-cents');
      if (cents === null || cents === '') continue;
      els[i].textContent = formatMoney(cents, activeCurrency);
    }
  }

  // Checkout always charges in USD regardless of displayed currency, so the cart
  // page spells that out under the total once a non-USD currency is active.
  function updateCartCurrencyNote() {
    var note = document.getElementById('cart-currency-note');
    if (!note) return;
    var cents = note.getAttribute('data-cart-total-cents');
    if (!ratesData || !cents || activeCurrency === DEFAULT_CURRENCY) {
      note.style.display = 'none';
      return;
    }
    // Plain "$" (not formatMoney's Intl-driven "US$") since the template already
    // spells out "USD" right after this amount.
    var usdFormatted = '$' + (parseFloat(cents) / 100).toFixed(2);
    var convertedFormatted = formatMoney(cents, activeCurrency);
    // Template comes from locales/*.json (cart.general.currency_note) via Liquid's `t`
    // filter, so this follows the page's actual locale (e.g. /ja/) regardless of currency.
    var template = note.getAttribute('data-note-template') ||
      "You'll be charged {usdAmount} USD. That's approximately {convertedAmount} {currency} at today's exchange rate.";
    note.textContent = template
      .replace('{usdAmount}', usdFormatted)
      .replace('{convertedAmount}', convertedFormatted)
      .replace('{currency}', activeCurrency);
    note.style.display = '';
  }

  function updateChangeLinks() {
    var links = document.querySelectorAll('.currency-change-link');
    for (var i = 0; i < links.length; i++) {
      links[i].textContent = 'Change currency';
    }
  }

  // Cart attributes carry through to checkout (unlike cookies, which don't cross to
  // Shopify's separate checkout domain) — the checkout UI extension reads this to show
  // a "you'll be charged in USD" note in the customer's preferred currency.
  function syncCartAttribute(currency) {
    var rate = ratesData && ratesData.rates[currency];
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          preferred_currency: currency,
          preferred_currency_rate: rate ? String(rate) : ''
        }
      })
    }).catch(function () {});
  }

  function setActiveCurrency(currency) {
    if (!isSupported(currency)) return;
    activeCurrency = currency;
    setCookie(COOKIE_NAME, currency, COOKIE_DAYS);
    convertAll();
    updateChangeLinks();
    updateCartCurrencyNote();
    syncCartAttribute(currency);
    var select = document.getElementById('CurrencySelect');
    if (select) select.value = currency;
  }

  function initSwitcher() {
    var select = document.getElementById('CurrencySelect');
    if (!select) return;
    select.value = activeCurrency;
    select.addEventListener('change', function () {
      setActiveCurrency(select.value);
    });
  }

  function openCurrencyModal() {
    if (document.querySelector('.currency-modal-backdrop')) return; // already open

    var backdrop = document.createElement('div');
    backdrop.className = 'currency-modal-backdrop';

    var optionsHtml = SUPPORTED.map(function (code) {
      var activeClass = code === activeCurrency ? ' is-active' : '';
      return '<button type="button" class="currency-modal__option' + activeClass + '" data-currency="' + code + '">' + code + '</button>';
    }).join('');

    backdrop.innerHTML =
      '<div class="currency-modal">' +
      '<div class="currency-modal__header">' +
      '<span class="currency-modal__title">Choose currency</span>' +
      '<button type="button" class="currency-modal__close" aria-label="Close">&times;</button>' +
      '</div>' +
      '<div class="currency-modal__list">' + optionsHtml + '</div>' +
      '</div>';

    document.body.appendChild(backdrop);

    function close() {
      backdrop.remove();
    }

    backdrop.addEventListener('click', function (evt) {
      if (evt.target === backdrop) close();
    });
    backdrop.querySelector('.currency-modal__close').addEventListener('click', close);

    var optionButtons = backdrop.querySelectorAll('.currency-modal__option');
    for (var i = 0; i < optionButtons.length; i++) {
      optionButtons[i].addEventListener('click', function () {
        setActiveCurrency(this.getAttribute('data-currency'));
        close();
      });
    }
  }

  function bindChangeLinks() {
    var links = document.querySelectorAll('.currency-change-link');
    for (var i = 0; i < links.length; i++) {
      links[i].addEventListener('click', function (evt) {
        evt.preventDefault();
        openCurrencyModal();
      });
    }
  }

  // Reconvert PDP price elements after theme.js's ProductSelect widget rewrites them
  // on variant change (assets/theme.js _updatePrice — see #ProductPrice-*/#ComparePrice-*).
  function bindVariantPriceChange() {
    if (typeof jQuery === 'undefined') return;
    jQuery(document).on('variantPriceChange', function (evt) {
      var variant = evt.variant;
      if (!variant || !ratesData) return;

      var priceEls = document.querySelectorAll('[id^="ProductPrice-"]');
      for (var i = 0; i < priceEls.length; i++) {
        priceEls[i].setAttribute('data-price-cents', variant.price);
        priceEls[i].textContent = formatMoney(variant.price, activeCurrency);
      }

      var compareEls = document.querySelectorAll('[id^="ComparePrice-"]');
      for (var j = 0; j < compareEls.length; j++) {
        compareEls[j].setAttribute('data-price-cents', variant.compare_at_price);
        compareEls[j].textContent = formatMoney(variant.compare_at_price, activeCurrency);
      }

      // PayPal "Pay in 4" installment price (sections/product-template.liquid) is a
      // quarter of the variant price and needs the same reconversion on variant change.
      var payIn4Els = document.querySelectorAll('[id^="PayIn4Price-"]');
      for (var k = 0; k < payIn4Els.length; k++) {
        var installmentCents = variant.price / 4;
        payIn4Els[k].setAttribute('data-price-cents', installmentCents);
        payIn4Els[k].textContent = formatMoney(installmentCents, activeCurrency);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (!ratesData) return; // metafield not populated yet — leave USD prices as rendered
    convertAll();
    updateChangeLinks();
    updateCartCurrencyNote();
    initSwitcher();
    bindChangeLinks();
    bindVariantPriceChange();
    syncCartAttribute(activeCurrency);
  });
})();
